import { DatasetId } from "@intelligems/ig-types/schemas/analytics/base";
import { useIsFetching } from "@tanstack/react-query";

export const useAnalyticsFetching = (datasetId?: DatasetId) => {
  return useIsFetching({
    predicate: (query) => {
      // Check if the query key contains 'variation_timeseries_cumulative'
      return query.queryKey.some(
        (key) =>
          typeof key === "object" &&
          JSON.stringify(key).includes(datasetId ?? "variation_overview")
      );
    },
  });
};
